/** 역할 라벨 */
export const ROLE_LABELS = {
  GROOM: '신랑',
  BRIDE: '신부',
  FATHER: '아버지',
  MOTHER: '어머니',
};

/** 측 구분 라벨 */
export const SIDE_LABELS = {
  GROOM: '신랑측',
  BRIDE: '신부측',
};

/** 신랑·신부 */
export const COUPLE = {
  groomName: '광수',
  brideName: '기정',
};

/** 신랑 측 가족 */
export const GROOM_FAMILY = {
  groom: {
    name: COUPLE.groomName,
    relation: '의 아들',
    phone: '01026371572',
    bank: '새마을금고',
    account: '9003-2192-7897-3',
  },
  father: {
    name: '진성호',
    phone: '01093172264',
    bank: '우리은행',
    account: '1002-047-163350',
  },
  mother: {
    name: '경미자',
    phone: '01050281572',
    bank: '농협은행',
    account: '302-0600-150641',
  },
};

/** 신부 측 가족 */
export const BRIDE_FAMILY = {
  bride: {
    name: COUPLE.brideName,
    relation: '의 딸',
    phone: '01091063681',
    bank: '새마을금고',
    account: '9003-2279-3469-4',
  },
  father: {
    name: '김성호',
    phone: '01035483681',
    bank: '농협은행',
    account: '741066-52-008751',
  },
  mother: {
    name: '김경자',
    phone: '01035403681',
    bank: '신한은행',
    account: '110-327-484303',
  },
};

/** 결혼식 일정 */
export const WEDDING_DATE = {
  year: 2026,
  month: 10,
  day: 31,
  hour: 11,
  minute: 30,
  coverDisplay: '2026년 10월 31일, 토요일 낮 11시 30분',
  calendarDisplay: '2026년 10월 31일 토요일 낮 11시 30분',
  isoString: '2026-10-31T11:30:00+0900',
  daysInMonth: 31,
  firstDayOfWeek: 4,
  weddingDay: 31,
  holidayDays: [9],
};

/** 예식장·오시는 길 */
export const VENUE = {
  name: 'BW웨딩 보네르홀',
  address: '경북 구미시 옥계2공단로 583 BW웨딩홀',
  directions: 'BW웨딩 보네르홀 주차장에 주차 후 오시면 됩니다.',
  lat: 36.1571646,
  lng: 128.4152516,
  naverMapUrl: 'https://naver.me/5N15VTfC',
  kakaoMapUrl: 'https://kko.to/q47DDm2BLz',
  charterBus: {
    ceremonyTime: '오전 11시 30분 예식',
    timetableUrl: 'http://bwwedding.co.kr/doc/time.php',
    outbound: [
      { stop: '구미역', time: '10:00' },
      { stop: '터미널네거리', time: '10:05' },
    ],
    returnTrip: [
      { stop: 'BW웨딩', time: '13:30' },
      { stop: '터미널네거리', time: '13:47' },
      { stop: '구미역', time: '13:52' },
    ],
    boardingLocations: [
      { stop: '구미역', description: '구미역 옆 나이키 매장 앞 (1번 출구에서 우측으로 60m)' },
      { stop: '터미널네거리', description: '오성예식장 앞 (구미경찰서 방면)' },
    ],
    operator: '아리랑 고속관광',
    notes: [
      '탑승 시 청첩장 또는 모바일 청첩장을 반드시 제시해 주세요.',
      '구미역·터미널네거리의 하차 위치는 승차 장소의 반대편입니다.',
      '당일 교통 상황에 따라 운행 시간이 달라질 수 있습니다.',
    ],
  },
};

/** 커버 섹션 */
export const COVER = {
  title: 'Our Wedding Day',
};

/** 초대장 섹션 */
export const INVITATION = {
  title: '초대합니다',
  paragraphs: [
    '지금까지 소중한 인연을 지켜왔습니다.',
    '앞으로 남은 인생은 가족이 되어',
    '같은 곳을 바라보며',
    '함께 걷고자 합니다.',
    '두 사람의 새로운 시작을',
    '함께 축복해주시면 감사하겠습니다.',
  ],
};

/** 푸터 */
export const FOOTER = {
  designedBy: 'Designed by Youngeun Suh',
  copyright: '© 2024 All rights reserved by Youngeun Suh.',
};

export const formatPersonLabel = (role, name) => `${role} ${name}`;

export const formatAccount = ({ bank, account }) => `${bank} ${account}`;

const toPhoneContact = (role, member) => ({
  person: formatPersonLabel(role, member.name),
  phone: member.phone,
});

const toAccountContact = (role, member) => ({
  person: formatPersonLabel(role, member.name),
  account: formatAccount(member),
});

export const GROOM_PHONE_CONTACTS = [
  toPhoneContact(ROLE_LABELS.GROOM, GROOM_FAMILY.groom),
  toPhoneContact(ROLE_LABELS.FATHER, GROOM_FAMILY.father),
  toPhoneContact(ROLE_LABELS.MOTHER, GROOM_FAMILY.mother),
];

export const BRIDE_PHONE_CONTACTS = [
  toPhoneContact(ROLE_LABELS.BRIDE, BRIDE_FAMILY.bride),
  toPhoneContact(ROLE_LABELS.FATHER, BRIDE_FAMILY.father),
  toPhoneContact(ROLE_LABELS.MOTHER, BRIDE_FAMILY.mother),
];

export const GROOM_ACCOUNT_CONTACTS = [
  toAccountContact(ROLE_LABELS.GROOM, GROOM_FAMILY.groom),
  toAccountContact(ROLE_LABELS.FATHER, GROOM_FAMILY.father),
  toAccountContact(ROLE_LABELS.MOTHER, GROOM_FAMILY.mother),
];

export const BRIDE_ACCOUNT_CONTACTS = [
  toAccountContact(ROLE_LABELS.BRIDE, BRIDE_FAMILY.bride),
  toAccountContact(ROLE_LABELS.FATHER, BRIDE_FAMILY.father),
  toAccountContact(ROLE_LABELS.MOTHER, BRIDE_FAMILY.mother),
];

export const COUPLE_DISPLAY = `${ROLE_LABELS.GROOM}♥${ROLE_LABELS.BRIDE}`;
